const grey = {
  1: '#F9FAFB',
  2: '#F2F2F4',
  3: '#E1E4E6',
  4: '#D9DADD',
  5: '#C8CACD',
  6: '#ACAEB2',
  7: '#91939A',
  8: '#6E7277',
  9: '#393C43',
  10: '#14161B',
};

const coolGrey = {
  1: '#F5F7FA',
  2: '#F1F3F7',
  3: '#EDEFF4',
  4: '#E6E8EE',
  5: '#D6D9E5',
  6: '#A1ABC5',
  7: '#818FB2',
  8: '#5D6E98',
  9: '#3F4A66',
  10: '#2F384C',
};

const teal = {
  1: '#ebfefe',
  2: '#d0f9f7',
  3: '#b7ecea',
  4: '#89d4d2',
  5: '#61c6c3',
  6: '#3cb3af',
  7: '#169692',
  8: '#137370',
  9: '#1f413d',
  10: '#142e2e',
};

const green = {
  1: '#e8ffeb',
  2: '#d4feda',
  3: '#b7f8c0',
  4: '#a3f0ad',
  5: '#88e3a3',
  6: '#6dd38c',
  7: '#4bb56b',
  8: '#368f51',
  9: '#19441f',
  10: '#071609',
};

const blue = {
  1: '#ebf8fe',
  2: '#d0f0ff',
  3: '#b9e9ff',
  4: '#88d8fc',
  5: '#44b5e7',
  6: '#1a90c4',
  7: '#0877a8',
  8: '#01587e',
  9: '#012f43',
  10: '#001a25',
};

const purple = {
  1: '#f3f0ff',
  2: '#e5deff',
  3: '#c7bdff',
  4: '#b4a5ff',
  5: '#9786ed',
  6: '#725ed7',
  7: '#5744b8',
  8: '#362491',
  9: '#180f46',
  10: '#0d072a',
};

const pink = {
  1: '#fff0ff',
  2: '#fbdeff',
  3: '#efbdff',
  4: '#e9a5ff',
  5: '#dc86ed',
  6: '#ca5ed7',
  7: '#ae44b8',
  8: '#912491',
  9: '#460f46',
  10: '#2a0729',
};

const yellow = {
  1: '#fffabe',
  2: '#fff79c',
  3: '#fef479',
  4: '#faeb37',
  5: '#f0de01',
  6: '#cfc000',
  7: '#9c9100',
  8: '#6d6500',
  9: '#46400b',
  10: '#2e2a10',
};

const orange = {
  1: '#ffe7d6',
  2: '#ffd5b7',
  3: '#ffbb8a',
  4: '#fea361',
  5: '#ed8235',
  6: '#d6691b',
  7: '#c65300',
  8: '#9c4100',
  9: '#673008',
  10: '#431d02',
};

const red = {
  1: '#FFCDCD',
  2: '#FFA4A4',
  3: '#FF8888',
  4: '#FF9D9D',
  5: '#CF4945',
  6: '#C73833',
  7: '#A61714',
  8: '#870300',
  9: '#4D0500',
  10: '#190100',
};

const white = '#ffffff';
const black = '#000000';
const hyperlinkBlue = '#008afc';

const primary = {
  main: '#3D56E7',
  light: '#3D56E7',
  dark: '#2b42c9',
};

export default {
  grey,
  coolGrey,
  teal,
  green,
  blue,
  purple,
  pink,
  yellow,
  orange,
  red,
  white,
  black,
  primary,
  hyperlinkBlue,
};
